import { Power4, Sine, TimelineMax, TweenLite  } from "gsap";
import * as HLF from "html-living-framework";
import * as Constants from "../Data/Constants";

export class KeyboardFocus extends PIXI.Container {
    private _corners: PIXI.Sprite[];
    private _tweenAlpha: TweenLite | undefined;
    private _tweenLoop: TimelineMax | undefined;
    private _animPerc: number;
    private _target: HLF.Input.IFocusable | undefined;

    constructor() {
        super();
        this._animPerc = 0;

        this._corners = new Array<PIXI.Sprite>(4);
        for (let i = 0; i < this._corners.length; ++i) {
            this._corners[i] = HLF.PixiUtils.makeSprite("keyboard-focus", Constants.SPRITESHEET_UI);
            this._corners[i].rotation = i * Math.PI * 0.5;
            this.addChild(this._corners[i]);
        }
        this.hide(undefined, true);
    }

    public get target(): HLF.Input.IFocusable | undefined {
        return this._target;
    }

    public show(pFocusable: HLF.Input.IFocusable): void {
        this.killTweens();

        this._target = pFocusable;
        this.fitToTarget();

        this._tweenAlpha = TweenLite.to(this, 0.25, {
            alpha: 1,
            ease: Sine.easeInOut,
        });
        this._animPerc = 0;

        this._tweenLoop = new TimelineMax({
            repeat: -1,
            onUpdate: this.updateCorners.bind(this),
        });
        this._tweenLoop.to(this, 0.5, {
            animPerc: 1,
            ease: Power4.easeOut,
        });
        this._tweenLoop.to(this, 0.5, {
            animPerc: 0,
            ease: Power4.easeIn,
        });
    }

    public hide(pOnComplete?: () => void, pInstantly: boolean = false): void {
        this.killTweens();

        this._target = undefined;

        this._tweenAlpha = TweenLite.to(this, pInstantly ? 0 : 0.1, {
            alpha: 0,
            ease: Sine.easeInOut,
            onComplete: pOnComplete,
        });
    }

    public onResize(): void {
        if (this._target !== undefined && this._tweenLoop !== undefined && this._tweenLoop.isActive) {
            this.fitToTarget();
        }
    }

    public fitToTarget(): void {
        if (this._target !== undefined) {
            this.position.copy(this.parent.worldTransform.applyInverse(this._target.getFocusPosition()));
            const size: PIXI.Point = this._target.getFocusSize();
            for (let i = 0; i < this._corners.length; ++i) {
                this._corners[i].x = size.x * 0.5 * ((i === 1 || i === 2) ? 1 : -1);
                this._corners[i].y = size.y * 0.5 * ((Math.floor(i / 2) === 0) ? -1 : 1);
            }
        }
    }

    private killTweens(): void {
        if (this._tweenLoop !== undefined) {
            this._tweenLoop.kill();
        }
        if (this._tweenAlpha !== undefined) {
            this._tweenAlpha.kill();
        }
    }

    private get animPerc(): number {
        return this._animPerc;
    }

    private set animPerc(pValue: number) {
        this._animPerc = pValue;
    }

    private updateCorners(): void {
        for (const corner of this._corners) {
            corner.anchor.set(0.5 + 0.15 * this._animPerc);
        }
    }
}
